import {useKeyPress} from '@github-ui/use-key-press'
import {useState} from 'react'

type LazyItemPickerProps = {
  hotkey?: string
  anchorElement: (props: React.HTMLAttributes<HTMLElement>) => JSX.Element
  createChild: () => JSX.Element
}

export function LazyItemPicker({anchorElement, createChild, hotkey}: LazyItemPickerProps): JSX.Element {
  const [wasTriggered, setWasTriggered] = useState(false)
  useKeyPress(hotkey ? [hotkey] : [], (e: KeyboardEvent) => {
    if (!wasTriggered) {
      setWasTriggered(true)
      e.preventDefault()
    }
  })

  if (!wasTriggered) {
    return anchorElement({onClick: () => setWasTriggered(true)})
  }

  return createChild()
}

try{ LazyItemPicker.displayName ||= 'LazyItemPicker' } catch {}